import { render } from "./AddressBookDetail.vue?vue&type=template&id=43e3c941"
import script from "./AddressBookDetail.vue?vue&type=script&lang=ts"
export * from "./AddressBookDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script